import React from 'react'
import styled from 'styled-components'
import { Paper } from '@olxbr/design-system'
import PropTypes from 'prop-types'

import medias from '../../../util/medias'
import RegisterWithTokenTemplate from '../../templates/RegisterWithTokenTemplate'

const ContentWrapper = styled(Paper)`
  display: flex;
  flex-direction: column;
  margin: ${() => '64px auto'};
  max-width: 466px;
  padding: 32px 64px;
  ${medias.small`
    margin: 24px 0;
  `}
`

export const RegisterWithTokenPage = ({
  abTests,
  onError,
  onRegisterSuccess,
  onRetryRegister,
  token,
}) => {
  return (
    <ContentWrapper>
      <RegisterWithTokenTemplate
        abTests={abTests}
        onError={onError}
        onRegisterSuccess={onRegisterSuccess}
        onRetryRegister={onRetryRegister}
        token={token}
      />
    </ContentWrapper>
  )
}

RegisterWithTokenPage.propTypes = {
  abTests: PropTypes.string,
  onError: PropTypes.func.isRequired,
  onRegisterSuccess: PropTypes.func.isRequired,
  onRetryRegister: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
}
